module.exports = __webpack_public_path__ + "static/img/logo.88eff08b.gif";